import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'

export interface TenantBudgetStatus {
  has_threshold: boolean
  threshold_usd?: number | null
  alert_at_pct?: number | null
  currency?: string | null
  exceeded?: boolean
  alert?: boolean
}

export interface TenantBudgetPayload {
  threshold_usd: number
  alert_at_pct: number
  currency?: string
}

export function useTenantBudgetStatus(tenantId: number, options?: { enabled?: boolean }) {
  return useQuery<TenantBudgetStatus>({
    queryKey: ['budget', tenantId],
    queryFn: async () => {
      const res = await api.get<TenantBudgetStatus>(`/v1/tenants/${tenantId}/budget/me`)
      return res.data
    },
    enabled: options?.enabled ?? true,
  })
}

export function useTenantBudgetSave(tenantId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (payload: TenantBudgetPayload) => {
      const res = await api.post(`/v1/tenants/${tenantId}/budget/me`, payload)
      return res.data
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['budget', tenantId] })
      // card "Budget Usado" do dashboard lê via get_finops_summary
      qc.invalidateQueries({ queryKey: ['finops-summary', tenantId] })
    },
  })
}
